// Port de fe-escrita-app/apps/mobile/src/utils/postFormatter.ts (fonte da verdade)
const REFERENCE_PATTERN = /([1-3]?\s?[A-Za-zÀ-ÿ]+)\s+\d+:\d+/;

const SHORT_PRAYERS = {
  'Gratidão':
    'Senhor, obrigado por cada bênção que muitas vezes passo sem perceber. Que eu viva este dia com um coração grato e atento à Tua presença. Amém.',
  'Esperança':
    'Deus, quando o caminho parece incerto, lembro que Tu tens planos de bem para mim. Renova minha esperança e me faz seguir com confiança em Ti. Amém.',
  'Paz':
    'Pai, entrego a Ti as preocupações que carrego. Que a Tua paz, que excede todo entendimento, guarde meu coração e minha mente hoje. Amém.',
  'Família':
    'Senhor, abençoa cada pessoa da minha família. Que Teu amor seja o fio que nos une e que nossa casa seja um lugar de graça e alegria. Amém.',
  'Perseverança':
    'Deus, nos momentos em que quero desistir, lembra-me de que posso tudo em Cristo que me fortalece. Dá-me forças para continuar sem perder a fé. Amém.',
  'Fé': 'Senhor, aumenta a minha fé. Nos momentos de dúvida, que eu olhe para Ti e lembre que Tu és fiel a cada promessa. Amém.',
  'Devocional':
    'Senhor, guarda esta mensagem em meu coração e me ajuda a viver este dia com fé, serenidade e amor. Amém.'
};

const THEME_TINTS = {
  'Gratidão': '#F1EBE1',
  'Esperança': '#DDE8DF',
  'Paz': '#DDE8DF',
  'Família': '#F1EBE1',
  'Perseverança': '#EFE4DC',
  'Fé': '#DDE8DF',
  'Devocional': '#F1EBE1'
};

function splitVerse(content) {
  const separator = content.includes(' – ') ? ' – ' : content.includes(' - ') ? ' - ' : '';

  if (!separator) {
    return { reflection: content, verse: null };
  }

  const [possibleVerse, ...rest] = content.split(separator);
  const remainder = rest.join(separator).trim();

  if (!remainder || !REFERENCE_PATTERN.test(possibleVerse)) {
    return { reflection: content, verse: null };
  }

  const referenceMatch = possibleVerse.match(REFERENCE_PATTERN);
  const reference = referenceMatch ? referenceMatch[0] : '';

  return {
    reflection: remainder,
    verse: {
      text: possibleVerse.replace(reference, '').replace(/[.,;:\s]+$/, '').trim(),
      reference
    }
  };
}

function buildExcerpt(text, maxLength = 150) {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trim()}...`;
}

function inferTheme(post) {
  const content = `${post.title} ${post.content}`.toLowerCase();

  if (content.includes('gratid')) return 'Gratidão';
  if (content.includes('esperan')) return 'Esperança';
  if (content.includes('ansied') || content.includes('paz')) return 'Paz';
  if (content.includes('famil')) return 'Família';
  if (content.includes('persever')) return 'Perseverança';
  if (content.includes('fé') || content.includes('fe ')) return 'Fé';

  return 'Devocional';
}

export function structurePost(post) {
  const parsed = splitVerse(String(post.content || ''));
  const reflection = parsed.reflection.trim();
  const theme = inferTheme(post);

  return {
    ...post,
    reflection,
    excerpt: buildExcerpt(reflection),
    theme,
    verse: parsed.verse,
    shortPrayer: SHORT_PRAYERS[theme] || SHORT_PRAYERS['Devocional']
  };
}

export function structurePosts(posts) {
  return posts.map(structurePost);
}

export function themeTint(theme) {
  return THEME_TINTS[theme] || '#F1EBE1';
}

export function shorten(text, maxLength) {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength).trim()}...` : text;
}
